export interface Card {
  cardUUID: string;
  issuerName: string;
  network?: string;
  issuerCardID: string;
  status: string;
  last4: string;
  pan?: string;
  cvv?: string;
  expiryMonth?: string;
  expiryYear?: string;
}

export const isValidCard = (val: unknown): val is Card => {
  if (typeof val !== 'object' || val === null) return false;

  const requiredFields = [
    'cardUUID',
    'issuerName',
    'issuerCardID',
    'status',
    'last4',
  ];

  if (
    !requiredFields.every(
      (field) => typeof (val as Record<string, unknown>)[field] === 'string'
    )
  ) {
    return false;
  }

  return true;
};
